export default __webpack_public_path__ + "static/media/mockStudentPicBig.7fb88486.png";